/**
 * Robots Meta Tag Service
 * Manages robots meta tags for SEO (noindex, nofollow)
 */

export class RobotsService {
	/**
	 * Add or update robots meta tag
	 * @param {string} content - Robots directive (e.g., "noindex, nofollow")
	 */
	setRobotsMeta(content) {
		// Remove existing robots meta tag
		this.removeRobotsMeta();

		// Add new robots meta tag
		const meta = document.createElement("meta");
		meta.name = "robots";
		meta.content = content;
		document.head.appendChild(meta);
	}

	/**
	 * Remove robots meta tag from document head
	 */
	removeRobotsMeta() {
		const existingMeta = document.querySelector("meta[name='robots']");
		if (existingMeta) {
			existingMeta.remove();
		}
	}

	/**
	 * Set noindex, nofollow for pages that should not be indexed
	 */
	setNoIndex() {
		this.setRobotsMeta("noindex, nofollow");
	}

	/**
	 * Remove noindex directive (allow indexing)
	 */
	allowIndex() {
		this.removeRobotsMeta();
	}
}

// Export singleton instance
export const robotsService = new RobotsService();

